export default "__VITE_ASSET__CTrVhOWV__"